<template>

  <div class="ob-toolbar">
    <h1 v-if="large"><slot name="head"></slot></h1>
    <h2 v-if="medium"><slot name="head"></slot></h2>
    <h3 v-if="small"><slot name="head"></slot></h3>

    <ob-button-group class="text-right controls" v-if="$scopedSlots && !!$scopedSlots.controls">
      <slot name="controls"></slot>
    </ob-button-group>
  </div>

</template>

<script>
  import ObButtonGroup from './components/button-group'

  export default {
    name: 'toolbar',

    props: {
      medium: Boolean,
      small: Boolean
    },

    computed: {
      large () {
        return !this.medium && !this.small
      }
    },

    components: {
      ObButtonGroup
    }
  }
</script>

<style scoped lang="scss">

  @import '../../assets/variables';
  @import '../../assets/responsive';

  .ob-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: $spacing-default;

    h1 {
      font-weight: 300;
    }

    h2 {
      font-weight: 300;
    }

    h3 {
      font-weight: 300;
    }
  }

  @include media('<tablet') {
    .ob-toolbar {
      flex-direction: column;
    }

    .controls {
      margin-top: $spacing-default;
    }

    h1, h2, h3 {
      text-align: center;
    }
  }

</style>
